//used for Edit form
const FloatingRightSingleFormDownFromSearchPark = {
  top: "22%",
  right: 4,
  position: "fixed",
  background: "whitesmoke",
  borderRadius: "0.25rem",
  width: "300px",
  height: "auto",
  padding: "20px",
  bottom: "5%",
  zIndex: 1,
  verticalAlign: "middle",
  boxSizing: "border-box",
  overflow: "auto",
  pl: 2,
  pt: 1,
};
//used for asign info to map
const FloatingRightSingleFormNearTop = {
  top: "15%",
  right: 4,
  position: "fixed",
  background: "whitesmoke",
  borderRadius: "0.25rem",
  width: "300px",
  height: "fit-content",
  padding: "20px",
  bottom: "10%",
  zIndex: 1,
  verticalAlign: "middle",
  boxSizing: "border-box",
  overflow: "auto",
};
const FloatingRightMultipleForm = {
  top: "25%",
  right: "20px",
  position: "fixed",
  background: "whitesmoke",
  borderRadius: "0.25rem",
  width: "300px",
  height: "fit-content",
  padding: "20px",
  bottom: "10%",
  zIndex: 1,
  verticalAlign: "middle",
  boxSizing: "border-box",
};
export { FloatingRightSingleFormDownFromSearchPark, FloatingRightMultipleForm, FloatingRightSingleFormNearTop };
